import { Box, FormControl, FormLabel, Grid, Paper, RadioGroup, Stack, Typography } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { RadioForm } from "~/src/components/molecules"
import { TUserProfile } from "~/src/repositories/User/models/User"
import { LabelTypography, TitleTypography, ValueTypography } from "./QuotationDetail.styles"

interface IQuotationDetailUserProps {
  user: TUserProfile  
}

export const QuotationDetailUser: React.FC<IQuotationDetailUserProps> = ({
  user
}): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Paper>
      <TitleTypography>
        {t('quotation_detail.member_information')}
      </TitleTypography>
      <Grid container px={3} pb={1}>
          <Grid item lg={6}>
            <Box display={'flex'} py={1.5}>
              <LabelTypography>
                {t('quotation_detail.company_name')}
              </LabelTypography>
              <ValueTypography>
                {user.companyName}
              </ValueTypography>
            </Box>
          </Grid>
          <Grid item lg={6}>
            <Box display={'flex'} py={1.5}>
              <LabelTypography>
                {t('quotation_detail.member_name')}
              </LabelTypography>
              <ValueTypography>
                {user.name}
              </ValueTypography>
            </Box>
          </Grid>
          <Grid item lg={6}>
            <Box display={'flex'} py={1.5}>
              <LabelTypography>
                {t('quotation_detail.country')}
              </LabelTypography>
              <ValueTypography>
                {user.country}
              </ValueTypography>
            </Box>
          </Grid>
          <Grid item lg={6}>
            <Box display={'flex'} py={1.5}>
              <LabelTypography>
                {t('quotation_detail.phone_number')}
              </LabelTypography>
              <ValueTypography>
                {user.tel}
              </ValueTypography>
            </Box>
          </Grid>
          <Grid item lg={6}>
            <Box display={'flex'} py={1.5}>
              <LabelTypography>
                {t('quotation_detail.email')}
              </LabelTypography>
              <ValueTypography>
                {user.email}
              </ValueTypography>
            </Box>
          </Grid>
          <Grid item lg={6}>
            <Box display={'flex'} py={1.5}>
              <LabelTypography>
                {t('quotation_detail.loading_port')}
              </LabelTypography>
              <ValueTypography>
                {user.loadingPort}
              </ValueTypography>
            </Box>
          </Grid>
      </Grid>
    </Paper>
  )
}